import React from 'react';
import { Button, Stack } from '@mui/material';
import { CartSummary } from '@api/ShoppingCart/ShoppingCart';
import { Order, isTableOrder } from '@api/Orders/Order';

// Rediseño QA 2026-08-26: los botones de Tarjeta/Transferencia se fueron — el
// tipo de pago se elige en el ModalPago (calculadora + selector) al cobrar.
// El botón de PROPINA también se fue (4ª ronda): la propina la elige el CLIENTE
// en su pantalla y llega sola al resumen del pedido — el cajero solo la ve, y
// puede quitarla con el bote de basura del resumen.
interface OrderActionButtonsProps {
    isEditing: boolean;
    shoppingCart?: CartSummary;
    waitingForPayment: boolean;
    setWaitingForPayment: (waiting: boolean) => void;
    currentOrder?: Order;
    onConfirmCreate: () => void;
    onConfirmComplete: () => void;
    onConfirmUpdate: () => void;
}

export const OrderActionButtons: React.FC<OrderActionButtonsProps> = ({
    isEditing,
    shoppingCart,
    waitingForPayment,
    setWaitingForPayment,
    currentOrder,
    onConfirmCreate,
    onConfirmComplete,
    onConfirmUpdate
}) => {
    const hasProducts = shoppingCart?.products && shoppingCart?.products?.length > 0;

    const getPrimaryButtonText = () => {
        if (isEditing) return 'Guardar';
        if (isTableOrder(currentOrder)) return 'Completar pedido';
        return 'Iniciar pedido';
    };

    const handlePrimaryAction = () => {
        if (isEditing) return onConfirmUpdate();
        if (isTableOrder(currentOrder)) return onConfirmComplete();
        return onConfirmCreate();
    };

    return (
        <Stack direction="row" spacing={2}>
            {/* "Por pagar" no aplica a una mesa retomada: en preparación se
                GUARDA (nunca se cobra) y lista se COMPLETA (siempre se cobra).
                Mostrarlo ahí solo servía para encender el flag que hacía que
                "Completar pedido" cerrara la mesa sin cobro. */}
            {!isTableOrder(currentOrder) && (
                <Button
                    disabled={!hasProducts}
                    fullWidth
                    onClick={() => setWaitingForPayment(!waitingForPayment)}
                    variant={waitingForPayment ? 'contained' : 'outlined'}
                >
                    Por pagar
                </Button>
            )}

            <Button disabled={!hasProducts} fullWidth color="success" variant="contained" onClick={handlePrimaryAction}>
                {getPrimaryButtonText()}
            </Button>
        </Stack>
    );
};
